<template>
	<div class="page">
		<top-header></top-header>
        <b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col cols="3">
                    <h4 class="text-uppercase"><b>Search CCMS</b></h4>
				</b-col>
				<b-col cols="6" class="text-center">
					
				</b-col>
				<b-col cols="3" class="text-right">
                    <b-form inline>
                        <b-form-input id="inline-form-input-name " v-model="search" class="mb-2 mr-sm-2 mb-sm-0" placeholder="IMEI No. / FP No. / Mobile No."></b-form-input>
                        <b-button variant="dark" pill @click="searchIMEI()">Search</b-button>
                    </b-form>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid class="mt-4">
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box" v-if="search_status == 1">
						<b-row class="mt-4 px-3">
							<b-col lg="12">
                                <b-table-simple hover small caption-top responsive>
                                    <!--<colgroup><col><col></colgroup>
                                    <colgroup><col><col><col></colgroup>
                                    <colgroup><col><col></colgroup>-->
                                    <b-thead head-variant="dark">
                                    <!--<b-tr>
                                        <b-th colspan="2">Location</b-th>
                                        <b-th colspan="3">Clothes</b-th>
                                        <b-th colspan="2">Accessories</b-th>
                                    </b-tr>-->
                                    <b-tr>
                                        <b-th>ULB</b-th>
                                        <b-th>Zone</b-th>
                                        <b-th>FP No.</b-th>
                                        <b-th>IMEI No.</b-th>
                                        <b-th>State ID</b-th>
                                        <b-th>Location</b-th>
                                        <b-th>Output Status</b-th>
                                        <b-th>Door Status</b-th>
                                        <b-th>Network Status</b-th>
                                        <b-th>Last Record Time</b-th>
                                    </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                    <b-tr>
                                        <!--<b-th rowspan="3">Belgium</b-th>
                                        <b-th class="text-right">Antwerp</b-th>-->
                                        <b-td>{{result.ulb_title}}</b-td>
                                        <b-td>{{result.zone_title}}</b-td>
                                        <b-td>{{result.feeder_pillar_no}}</b-td>
                                        <b-td>{{result.imei_no}}</b-td>
                                        <b-td variant="success">{{result.state_id}}</b-td>
                                        <b-td>{{result.location}}</b-td>
                                        <b-td>{{result.output_status}}</b-td>
                                        <b-td>{{result.door_status}}</b-td>
                                        <b-td>
                                            <b-link :href="'/device-fault/'+result.imei_no" v-if="connection_status == 2"><div><b-badge pill variant="warning">DATA FAULT</b-badge></div></b-link>
                                            <b-badge pill variant="danger" v-else-if="connection_status == 0">DISCONNECTED</b-badge>
                                            <b-badge pill variant="success" v-else>CONNECTED</b-badge>
                                        </b-td>
                                        <b-td>{{last_update_time}}</b-td>
                                    </b-tr>
                                    </b-tbody>
                                </b-table-simple>
								
							</b-col>
							<b-col lg="6">
							</b-col>
							<b-col lg="6" class="text-right">
								<b-button pill variant="primary" class="mr-1" v-if="$root.chkperm('find_device','sms')" @click="showSMSModal($event.target)" size="sm"><b-icon icon="envelope"></b-icon> SMS</b-button>
                                <b-button pill variant="primary" class="mr-1" v-if="$root.chkperm('find_device','replace')" @click="showReplaceModal($event.target)" size="sm"><b-icon icon="gear-fill"></b-icon> Replace</b-button>
                                <b-button pill variant="info" class="mr-1" v-if="$root.chkperm('find_device','view')" @click="showViewModal()" size="sm"><b-icon icon="search"></b-icon> View</b-button>
                                <b-button pill variant="primary" class="mr-1" v-if="$root.chkperm('find_device','edit')" @click="showUpdateModal($event.target)" size="sm"><b-icon icon="pencil"></b-icon> Update</b-button>
                                <b-button pill variant="danger" class="mr-1" v-if="$root.chkperm('find_device','delete')" @click="showDeleteModal()" size="sm"><b-icon icon="trash"></b-icon> Delete</b-button>
							</b-col>
						</b-row>
					</div>
                    <div class="container-box" v-else>
                        <p class="text-center">No Record</p>
                    </div>
				</b-col>
			</b-row>
			

            <b-modal id="replace-model" title="Replace Panel" size="lg" ok-only @hidden="resetSelectedItem" @ok="onReplaceDevice">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="replaceItem.replace_imei_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="replaceItem.feeder_pillar_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="replaceItem.replace_meter_no" disabled></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="replaceItem.mobile_no" disabled></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Replace Information</b-alert>
							<b-form-group label="New CCMS" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_imei_no" placeholder="New Imei no."></b-form-input>
							</b-form-group>
							<b-form-group label="New Meter" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="replaceItem.new_meter_no" placeholder="New Meter no."></b-form-input>
							</b-form-group>
							<b-form-group label="Replace Date" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-datepicker id="ward-input" v-model="replaceItem.replace_time" :date-format-options="{ year: 'numeric', month: 'long', day: '2-digit' }" required></b-form-datepicker>
							</b-form-group>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
            <b-modal id="sms-model" title="SMS" close-only>
				<b-container fluid>
					<b-row class="mb-1r">
						<b-col cols="4" class="pl-0 pr-1"><b-button size="sm" class="w-100" variant="success" @click="sendSMS(selectedItem.mobile_no,'LIGHTON')">LIGHT ON</b-button></b-col>
                        <b-col cols="4" class="pl-1 pr-1"><b-button size="sm" class="w-100" variant="danger" @click="sendSMS(selectedItem.mobile_no,'LIGHTOFF')">LIGHT OFF</b-button></b-col>
                        <b-col cols="4" class="pl-1 pr-1"><b-button size="sm" class="w-100" variant="warning" @click="sendSMS(selectedItem.mobile_no,'DEFAULT')">SET DEFAULT</b-button></b-col>
					</b-row>
					<b-row class="mb-1r mt-2">
						<b-col cols="6" class="pl-0 pr-1"><b-button size="sm" class="w-100" variant="info" @click="sendSMS(selectedItem.mobile_no,'IPADDR,216.10.251.190,32212')">SET IP (32212)</b-button></b-col>
						<b-col cols="6" class="pl-1 pr-1"><b-button size="sm" class="w-100" variant="info" @click="setRTC(selectedItem.mobile_no)">SET RTC ({{nowTime}})</b-button></b-col>
					</b-row>
				</b-container>
			</b-modal>

            <b-modal id="edit-model" :title="(selectedItem.id > 0)?'Edit CCMS | DCU':'Add CCMS | DCU'" size="xl" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="selectedItem.imei_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="selectedItem.feeder_pillar_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Device Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.device_type">
									<b-form-select-option value="CCMS">CCMS</b-form-select-option>
									<b-form-select-option value="DCU">DCU</b-form-select-option>
								</b-form-select>
							</b-form-group>
                            <b-form-group label="Meter Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.meter_type">
									<b-form-select-option value="3P">3 Phase</b-form-select-option>
									<b-form-select-option value="1P">1 Phase</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Meter No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="selectedItem.device_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="selectedItem.mobile_no" required></b-form-input>
							</b-form-group>
							<b-alert show variant="secondary" class="header-title">Map Information</b-alert>
							<b-form-group label="Latitude" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.location_lat" required></b-form-input>
							</b-form-group>
							<b-form-group label="Longitude" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.location_lng" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Location Information</b-alert>
							<b-form-group label="State" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" @change="selectedItem.zone_id=0; selectedItem.ulb_id=0" required></b-form-select>
							</b-form-group>
							<b-form-group label="Zone" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.zone_id">
									<b-form-select-option value="0">--- Select Zone ---</b-form-select-option>
									<b-form-select-option v-for="item in filterZone(zoneOptions)" v-bind:key="item.id" :value="item.id" @change="selectedItem.ulb_id=0">{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="ULB" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ulb_id">
									<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
									<b-form-select-option v-for="item in filterULB(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Location" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="selectedItem.location" required></b-form-input>
							</b-form-group>
							<b-form-group label="Ward No" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ward-input" v-model="selectedItem.ward_no" required></b-form-input>
							</b-form-group>
							<b-form-group label="Previous Load" label-for="prev-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="prevload-input" v-model="selectedItem.previous_load" required></b-form-input>
							</b-form-group>
							<b-form-group label="Total Load" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.total_load" required></b-form-input>
							</b-form-group>
							<!--<b-form-group label="Total Connection" v-if="selectedItem.device_type === 'CCMS'" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.total_connection" required></b-form-input>
							</b-form-group>-->
							<b-form-group label="No of Fittings" label-for="fitting-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fitting-input" v-model="selectedItem.no_of_fittings" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">LED Information</b-alert>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="18W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_18w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="24W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_24w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="35W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_35w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="45W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_45w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="70W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_70w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="75W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_75w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="110W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_110w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
									<b-form-group label="140W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_140w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row>
								<b-col class="pr-0">
									<b-form-group label="190W" label-cols="6" label-size="sm" label-align-sm="right">
										<b-form-input v-model="selectedItem.led_190w" @change="updateTotalLoad"></b-form-input>
									</b-form-group>
								</b-col>
								<b-col class="pl-0">
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";

export default {
	name: 'Devices',
	components: {
		"top-header": Header,
	},
	mounted(){
		var userinfo = this.$session.get('user_info');
		if(userinfo.role != 1){
			this.fields.splice(6,1);
			this.fields.splice(4,1);
			this.fields.splice(3,1);
		}
		
		this.loadzones()
		this.nowTimes();
	},
	data() {
		var self = this;
		
		return{
			loading: false, 
			last_sync_time: '',
			zoneOptions: [],
			networkfilter: -1,
            powerfilter: -1,

            connection_status: '',

            search: '',
            search_status: 0,
            result: {},
            
            filter_state_id: '',
            filter_zone_id: '',
            filter_ulb_id: '',

            nowTime: '',
			
			page_title: '',
            selectedUlb: self.$route.params.ulbareacode,
            zonesUrl: self.$session.get('apiurl')+'bareillyapi/zone-list',
			searchUrl: self.$session.get('apiurl')+'bareillyapi/search-device',
			recordUrl: self.$session.get('apiurl')+'bareillyapi/device-all',
			insertUrl: self.$session.get('apiurl')+'bareillyapi/device-insert',
			updateUrl: self.$session.get('apiurl')+'bareillyapi/device-update',
			deleteUrl: self.$session.get('apiurl')+'bareillyapi/device-delete',
			maintenanceUrl: self.$session.get('apiurl')+'bareillyapi/device-maintenance',
			replaceUrl: self.$session.get('apiurl')+'bareillyapi/replacepanel-insert',
			total_kwh: 0,
			device_on: 0,
			device_connected: 0,
			total_load: 0,
			current_load: 0,
			total_lights: 0,
			total_light_on: 0,
			total_light_off: 0,
			total_signal_loss: 0,
			filteredrecords: [],
			records: [],
			fields: [
				{ key: 'sno', label: 'S.No' },
				{ key: 'imei_no', label: 'IMEI No.', sortable: true, class: 'text-center' },
				{ key: 'data_length', label: 'Data Length.', sortable: true, class: 'text-center' },
				{ key: 'update_time', label: 'TimeStamp', 
					formatter: (value, key, item) => {
						/*if(item.data_fault == 1){
							return self.$moment(item.fault_time).format('DD-MM-YYYY HH:mm:ss');
						}*/
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
					},
				},
			],
			totalRows: 1,
			currentPage: 1,
			networkOptions: [{text:'All', value:-1}, {text:'Connected', value:1}, {text:'Disconnected', value:0}, {text:'Data Fault', value:2}],
			powerOptions: [{text:'All', value:-1}, {text:'ON', value:1}, {text:'OFF', value:0}, {text:'Power Failure', value:2}],
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			replaceItem: {},
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				feeder_pillar_no: '',
				ward_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				led_18w: 0,
				led_24w: 0,
				led_35w: 0,
				led_45w: 0,
				led_70w: 0,
				led_75w: 0,
				led_110w: 0,
				led_140w: 0,
				led_190w: 0,
				maintenance: 0
			},
			center: { lat: 0, lng: 0 },
			markers: [],
			places: [],
			currentPlace: null,
			infoWindowPos: null,
			infoWindowOpen: false,
			currentMarkerIndex: null,
			zoneinfo: {},
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
		};
	},
	methods: {
        nowTimes(){
			this.timeFormate(new Date());
			setInterval(this.nowTimes, 1000);
		},
		timeFormate(timeStamp) {
			let year = new Date(timeStamp).getFullYear().toString().substr(-2);
			let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
			let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
			let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
			let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
			let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
			
			this.nowTime = date+""+month+""+year+""+hh+""+mm+""+ss;
		},
        filterZoneDevices: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.state  == self.filter_state_id;
				}
			})
		},
		filterULBDevices: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.filter_zone_id && item.parent > 0;
			})
        },
        searchIMEI(){
            var self = this;
            
            if(self.search.length > 3 && self.search.length <= 15){
                self.loading = true;
                self.search_status = 0;

                self.axios.post(self.searchUrl, {
                    accesskey: self.$session.get('access_key'),
                    imei_no: self.search
                })
                .then(function (response) {
                    self.loading = false;
                    if(response.data.error == 0){
						self.result = response.data.result;
						if(self.result.length == 0){
							self.search_status = 0;
							return;
						}
                        self.search_status = 1;

                        self.last_update_time = '';
                        if(self.result.update_time == "" || self.result.update_time == "00-00-0000 00:00:00"){
							self.last_update_time = '-n/a-';
						}
                        self.last_update_time = self.$moment(self.result.update_time).format('DD-MM-YYYY HH:mm:ss');
                        
                        self.network_status = 0;

                        var curdatetime = self.$moment();
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
                        if(self.result.update_time != ""){
							dbdatetime = self.$moment(self.result.update_time);

							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
                            }
							minutes = duration.asMinutes();
							
							if(minutes < self.$root.disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}else{
							conn_status = 0;
						}
						self.connection_status = conn_status;
                        if(self.result.datalength != 59 && self.result.datalength != 210){
							self.connection_status = 2;
						}

                        var msg = 'Search Completed!';
                        self.$bvToast.toast(msg, {
                            title: 'Delete',
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 5000,
                            variant: 'warning',
                            solid: true,
                            appendToast: true
                        });
                    }else{
                        self.search_status = 0;
                    }
                })
                .catch(function (error) {
                    alert(error);
                });
            }
            
        },
        sendSMS(mobile, smstxt){
            var self = this;
            var url = 'http://sms.bmwebmedia.com/shn/api/pushsms.php?usr=624402&key=0105qJp302aRslvQCRCgLIpYL8meS0&sndr=RNDSMS&ph='+mobile+'&text='+smstxt+'&rpt=1'
            self.axios.get(url, {
                /*usr: '624402',
                key: '0105qJp302aRslvQCRCgLIpYL8meS0',
                sndr: 'TXTSMS',
                ph: mobile,
                text: smstxt,
                rpt: 1*/
            })
            .then(function (response) {
                console.log(response);
                    var msg = 'Message Sent!';
                    self.$bvToast.toast(msg, {
                        title: 'Delete',
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 5000,
                        variant: 'warning',
                        solid: true,
                        appendToast: true
                    });
            })
            .catch(function (error) {
                alert(error);
            });
        },
		onFilterDevices(){
			this.filteredrecords = this.filterDevices(this.records);
			this.totalRows = this.filteredrecords.length;
			this.currentPage = 1;
		},
		filterDevices(devices){
			var self = this;
			return devices.filter(function (d) {
				var valid = false;
				if(self.networkfilter < 0){
					//valid = true;
				}else if(self.networkfilter == 0){
					if(d.connection_status == 0 && d.datalength == 210){
						valid = true;
					}
				}else if(self.networkfilter == 1){
					if(d.connection_status == 1 && d.datalength == 210){
						valid = true;
					}
				}else if(self.networkfilter == 2){
					if(d.datalength != 59 && d.datalength != 210){
						valid = true;
					}
				}

				if(self.powerfilter < 0){
					//valid = true;
				}else if(self.powerfilter == 0){
					if(d.output_status == 0){
						valid = true;
					}
				}else if(self.powerfilter == 1){
					
					if(d.output_status == 1){
						valid = true;
					}
				}else if(self.powerfilter == 2){
					if(d.datalength == 59){
						valid = true;
					}
				}
				if(self.networkfilter < 0 && self.powerfilter< 0){
					valid = true;
				}
				if(valid){
					return d;
				}
			});
		},
		updateTotalLoad(){
			this.selectedItem.total_load = (parseInt(this.selectedItem.led_18w) * 18) + (parseInt(this.selectedItem.led_24w) * 24) + (parseInt(this.selectedItem.led_35w) * 35) + (parseInt(this.selectedItem.led_45w) * 45) + (parseInt(this.selectedItem.led_70w) * 70) + (parseInt(this.selectedItem.led_75w) * 75) + (parseInt(this.selectedItem.led_110w) * 110) + (parseInt(this.selectedItem.led_140w) * 140) + (parseInt(this.selectedItem.led_190w) * 190);

			this.selectedItem.no_of_fittings = parseInt(this.selectedItem.led_18w) + parseInt(this.selectedItem.led_24w) + parseInt(this.selectedItem.led_35w) + parseInt(this.selectedItem.led_45w) + parseInt(this.selectedItem.led_70w) + parseInt(this.selectedItem.led_75w) + parseInt(this.selectedItem.led_110w) + parseInt(this.selectedItem.led_140w) + parseInt(this.selectedItem.led_190w);
		},
		setMaintenance(val){
			var self = this;
			var maintenance_flag = -1;
			if(val.trigger == "maintenance_on"){
				maintenance_flag = 1;
			}
			else if(val.trigger == "maintenance_off"){
				maintenance_flag = 0;
			}

			if(maintenance_flag >= 0){
				var submitdata = new Object();
				submitdata.feeder_pillar_no = self.selectedItem.feeder_pillar_no;
				submitdata.maintenance = maintenance_flag;

				self.loading = true;
				//bvModalEvt.preventDefault();

				self.axios.post(self.maintenanceUrl, {
					accesskey: self.$session.get('access_key'),
					data: submitdata
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('view-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}
		},
		toogleMarkerInfoWindow(marker, index){
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext;
			if(this.currentMarkerIndex == index){
				this.infoWindowOpen = !this.infoWindowOpen;
			}else{
				this.infoWindowOpen = true;
				this.currentMarkerIndex = index;
			}
		},
		addMarker(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 35, height: 45, f: 'px', b: 'px'}, scaledSize: {width: 35, height: 45, f: 'px', b: 'px',}} });
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		addMarker2(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 60, height: 90, f: 'px', b: 'px'}, scaledSize: {width: 30, height: 45, f: 'px', b: 'px',}} });
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.state  == self.selectedItem.state_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.selectedItem.zone_id && item.parent > 0;
			})
		},
		showAddModal(){
			var self = this;
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.zoneOptions.forEach(function(field){
				if(field.areacode == self.selectedUlb){
					self.selectedItem.state_id = field.state;
					if(field.parent > 0){
						self.selectedItem.zone_id = field.parent;
					}
					if(field.parent > 0){
						self.selectedItem.ulb_id = field.id;
					}
				}
			});
			this.$root.$emit('bv::show::modal', 'edit-model');
		},
		showUpdateModal(item, index, button) {
            var self = this;
            this.selectedItem = {
				id: self.result.id,
				imei_no: self.result.imei_no,
				zone_id: self.result.zone_id,
				state_id: self.result.state_id,
                ulb_id: self.result.ulb_id,
                device_type: self.result.device_type,
                device_no: self.result.device_no,
                meter_type: self.result.meter_type,
                mobile_no: self.result.mobile_no,
				feeder_pillar_no: self.result.feeder_pillar_no,
                ward_no: self.result.ward_no,
                location: self.result.location,
                previous_load: self.result.previous_load,
                total_load: self.result.total_load,
				no_of_fittings: self.result.no_of_fittings,
				location_lat: self.result.location_lat,
				location_lng: self.result.location_lng,
				led_18w: self.result.led_18w,
				led_24w: self.result.led_24w,
				led_35w: self.result.led_35w,
				led_45w: self.result.led_45w,
				led_70w: self.result.led_70w,
				led_75w: self.result.led_75w,
				led_110w: self.result.led_110w,
				led_140w: self.result.led_140w,
				led_190w: self.result.led_190w,
				maintenance: 0
			};

			this.$root.$emit('bv::show::modal', 'edit-model', button)
        },
        showSMSModal(button){
			this.$root.$emit('bv::show::modal', 'sms-model', button);
        },
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showReplaceModal(item, button){
            var self = this;
			this.replaceItem = {
				replace_imei_no: self.result.imei_no,
				replace_meter_no: self.result.device_no,
				feeder_pillar_no: self.result.feeder_pillar_no,
				new_imei_no: '',
				new_meter_no: '',
				mobile_no: self.result.mobile_no,
				replace_time: '',
			};
			this.$root.$emit('bv::show::modal', 'replace-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete device.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		onReplaceDevice(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			
			self.axios.post(self.replaceUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.replaceItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('replace-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}
			
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneOptions = response.data.result;
					self.zoneOptions.forEach(function(field){
						if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;//+', '+field2.title+', Maharastra';
									}
								});
								//self.page_title = field.title+', Maharastra';
							}
						}
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		initload(){
			var self = this;
			self.records = [];
            
			const getData=()=>{
				fetch(self.$session.get('weburl')+'/nodejs/node_modules/npm/logs/unregistered.json',{
				//fetch('/unregistered.json',{
					headers : { 
						'Content-Type': 'application/json;charset=utf-8',
						'Accept': 'application/json'
					}
				})
				.then(function(response){
					return response.json();
				}).then((data) => {
					var i = 0;
					for(let value in data) {
						var timestamp = data[value].TIME;
						self.records.push({'sno':i++,'imei_no': value, 'data_length': data[value].DATA.length, 'ip': data[value].IP, 'update_time':new Date(timestamp).toLocaleDateString()+' '+new Date(timestamp).toLocaleTimeString()});
					//	console.log(' '+value+' '+data[value].TIME);
					}
					self.loading = false;
				});
			}
			getData();
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
	font-weight: 600;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.header-title{
	padding: 0.3rem 1.25rem;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
</style>